var Index_tab_feature_collect_2_block_slider = document.querySelector('.Index_tab_feature_collect_2_block_slider');

if (Index_tab_feature_collect_2_block_slider) {
    new Swiper('.Index_tab_feature_collect_2_block_slider', {
        loop: false,
        grabCursor: false,
        spaceBetween: 34,
        slidesPerGroup: 1,
        slidesPerView: 2,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        breakpoints: {
            0: {
                slidesPerView: "auto",
                spaceBetween: 16
            },
            750: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            990: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            1200: {
                slidesPerView: 2,
                spaceBetween: 34
            },
            1440: {
            }
        }
    })
}


var Index_tab_feature_collect_3_block_slider = document.querySelector('.Index_tab_feature_collect_3_block_slider');

if (Index_tab_feature_collect_3_block_slider) {
    new Swiper('.Index_tab_feature_collect_3_block_slider', {
        loop: false,
        grabCursor: false,
        spaceBetween: 34,
        slidesPerGroup: 1,
        slidesPerView: 3,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        breakpoints: {
            0: {
                slidesPerView: "auto",
                spaceBetween: 16
            },
            750: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            990: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 34
            },
            1440: {
            }
        }
    })
}